export default __webpack_public_path__ + "static/media/lights_03.43800f70.jpg";